import { HtmlEditor } from "devextreme-react";
import { Toolbar } from "devextreme-react/html-editor";
import { Item } from "devextreme-react/toolbar";
import { useEffect } from "react";

export default function OtherExperienceHtmlEditor(props) {
  const { otherExpereicneHtmlEditorRef, otherExperienceGridRef } = props;

  useEffect(() => {
    otherExpereicneHtmlEditorRef.current.instance.option(
      "value",
      otherExperienceGridRef.current.instance.getSelectedRowsData().length == 0
        ? null
        : otherExperienceGridRef.current.instance.getSelectedRowsData()[0]
            .otrExpOrHis
    );
  }, []);

  return (
    <HtmlEditor
      id="otherExpereicne"
      ref={otherExpereicneHtmlEditorRef}
      height={450}
      valueType="html"
    >
      <Toolbar multiline={true}>
        <Item name="undo" />
        <Item name="redo" />
        <Item name="separator" />
        <Item
          name="size"
          acceptedValues={[
            "8pt",
            "10pt",
            "12pt",
            "14pt",
            "18pt",
            "24pt",
            "36pt",
          ]}
        />
        <Item
          name="font"
          acceptedValues={[
            "Arial",
            "Courier New",
            "Georgia",
            "Impact",
            "Lucida Console",
            "Tahoma",
            "Times New Roman",
            "Verdana",
          ]}
        />
        <Item name="separator" />
        <Item name="bold" />
        <Item name="italic" />
        <Item name="strike" />
        <Item name="underline" />
        <Item name="separator" />
        <Item name="alignLeft" />
        <Item name="alignCenter" />
        <Item name="alignRight" />
        <Item name="alignJustify" />
        <Item name="separator" />
        <Item name="orderedList" />
        <Item name="bulletList" />
        <Item name="separator" />
        <Item name="header" acceptedValues={[false, 1, 2, 3, 4, 5]} />
        <Item name="separator" />
        <Item name="color" />
        <Item name="background" />
        <Item name="separator" />
        <Item name="link" />
        <Item name="separator" />
        <Item name="clear" />
        <Item name="codeBlock" />
        <Item name="blockquote" />
        <Item name="separator" />
        <Item name="insertTable" />
        <Item name="deleteTable" />
        <Item name="insertRowAbove" />
        <Item name="insertRowBelow" />
        <Item name="deleteRow" />
        <Item name="insertColumnLeft" />
        <Item name="insertColumnRight" />
        <Item name="deleteColumn" />
      </Toolbar>
    </HtmlEditor>
  );
}
